import { useServiceTypeTaskDefinitionsQuery } from '../queries/useServiceTypeTaskDefinitionsQuery';

import { createMutationHook } from '~/shared/providers/api';

export const useUpdateServiceTypeTaskDefinitionMutation = createMutationHook(
  'transportation.serviceTypeTaskDefinitionUpdate',
  (params: {
    id: string;
    allowLocationOverride?: boolean;
    assetRole?: string | null;
  }) => ({
    transportationServiceTypeTaskDefinitionUpdate: {
      __args: {
        id: params.id,
        input: {
          allowLocationOverride: params.allowLocationOverride,
          assetRole: params.assetRole,
        },
      },
      id: true,
      allowLocationOverride: true,
      assetRole: true,
      serviceTypeId: true,
    },
  }),
  {
    invalidateQueries: [useServiceTypeTaskDefinitionsQuery],
  },
);
